import { type Vue3MqConfig } from 'vue3-mq';

/**
 * Configuration options for vue3-mq.
 */
export const MQ_OPTIONS: Vue3MqConfig = {
	defaultBreakpoint: 'small',
	breakpoints: {
		initial: 0,
		small: 480,
		medium: 600,
		large: 1024,
		xlarge: 1200,
	},
};
